// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__button--w86UK {
  background: none;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__taskName--rQbqa {
  background: none;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__taskName--rQbqa:hover {
  text-decoration: underline;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__taskName--rQbqa.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__levelSpace--sr0m9 {
  padding-left: 46px;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__groupName--TsNc8 {
  background: none;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 700;
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__expandIcon--UrhJM {
  color: rgba(0, 0, 0, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Gantt/Planning2NameCell/Planning2NameCell.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEA;EAVE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAIA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;AAOF;AANE;EACE,0BAAA;AAQJ;AANE;EACE,kBAAA;AAQJ;AALA;EAxBE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAkBA,0BAAA;EACA,eAAA;EACA,gBAAA;EAEA,aAAA;EACA,QAAA;EACA,mBAAA;AAaF;AAXA;EACE,yBAAA;AAaF","sourcesContent":[".button {\n  background: none;\n  padding: 0;\n  margin: 0;\n  border: none;\n  cursor: pointer;\n\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.taskName {\n  .button();\n  display: block;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline;\n  }\n  &.levelSpace {\n    padding-left: 46px;\n  }\n}\n.groupName {\n  .button();\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-weight: 700;\n\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.expandIcon {\n  color: rgba(0, 0, 0, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__button--w86UK`,
	"taskName": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__taskName--rQbqa`,
	"levelSpace": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__levelSpace--sr0m9`,
	"groupName": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__groupName--TsNc8`,
	"expandIcon": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Gantt-Planning2NameCell-Planning2NameCell-module__expandIcon--UrhJM`
};
export default ___CSS_LOADER_EXPORT___;
